// extracted by css-extract-rspack-plugin
var _1 = "filter-l1X70d";
var _2 = "prompt-hFhpcf";
var _3 = "table-P33etB";
export { _1 as "filter", _2 as "prompt", _3 as "table" }
